<div
  class="cb-battle-middle-waiting-player"
  [class.nuclear]="battle().mode === 'nuclear'"
  [class.equity]="battle().mode === 'equity'"
  [class.crazy]="battle().mode === 'crazy'"
  [class.normal]="battle().mode === 'normal'"
  [class.player]="!!player()"
>
  <div
    class="cb-battle-middle-waiting-player--particles flex items-center justify-center"
  >
    <ngx-particles
      [id]="slot() + '-waiting-particles'"
      [options]="particlesOptions"
    ></ngx-particles>
  </div>
  @if (player()) {
  <span class="cb-battle-middle-waiting-player--ready typography-title"
    >Ready</span
  >
  } @else {
  <div class="cb-battle-middle-waiting-player--waiting">
    <span class="dots-animation typography-title">Waiting for players</span>
  </div>
  <button
    class="cb-battle-middle-waiting-player--button"
    (click)="isHost() ? handleCallBots() : handleJoinBattle()"
  >
    <app-game-icon color="black" [game]="'Case Battles'"></app-game-icon>
    @if (isHost()) { call bots } @else { join <span> for </span>
    <app-cost
      color="var(--black)"
      fontWeight="700"
      [gap]="4"
      [cost]="battle().value"
      [balanceType]="balance()"
    />
    }
  </button>
  }
</div>
